var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.toastState.visible)?_c('div',{staticClass:"toast",class:`toast-${_vm.toastState.type}`},[_vm._v(" "+_vm._s(_vm.toastState.message)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }